import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sucesstemp',
  templateUrl: './sucesstemp.component.html',
  styleUrls: ['./sucesstemp.component.css']
})
export class SucesstempComponent implements OnInit {
  @Input() assessment: any;
  @Input() message: any;
  @Input() fullMessage: string = '';

  constructor(public dialogRef: MatDialogRef<SucesstempComponent>, public router: Router) { }

  ngOnInit() {
    setTimeout(() => {
      this.dialogRef.close();
    }, 5000)
    this.loadScript();
  }
  public loadScript() {
    var isFound = false;
    var scripts = document.getElementsByTagName("script")
    for (var i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("loader")) {
        isFound = true;
      }
    }

    if (!isFound) {
      var dynamicScripts = ["./assets/js/animation.js"];

      for (var k = 0; k < dynamicScripts.length; k++) {
        let node = document.createElement('script');
        node.src = dynamicScripts[k];
        node.type = 'text/javascript';
        node.async = false;
        node.charset = 'utf-8';
        document.getElementsByTagName('head')[0].appendChild(node);
      }

    }
  }

}
